
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'

import {Api} from "../../utils/api"
import {Fetch} from "../../utils/storage"

export default {
name: 'InvoiceInfo-New',
components: {
Group,
XInput,
XButton,
XSwitch
},

created () {
},
data () {
return {
InvoiceInfo:{},
}
},
methods: {
async handleSubmit() {
let _this = this
if (
!_this.InvoiceInfo.TaxNumber ||
_this.InvoiceInfo.TaxNumber.length < 15) {
_this.$vux.toast.show({
text: '发票税号不可为空，且不得少于15位！',
type: 'text',
width:'3rem'
})
return
}
if (
!_this.InvoiceInfo.Title) {
_this.$vux.toast.show({
text: '发票税号不可为空，且不得少于15位！',
type: 'text',
width:'3rem'
})
return
}

if (!this.$refs.emailInput.valid) {
_this.$vux.toast.show({
text: '邮箱格式不正确！',
type: 'text',
width:'3rem'
})
return
}
if (!this.InvoiceInfo.Email) {
_this.$vux.toast.show({
text: '发票接受邮箱不可为空！',
type: 'text',
width:'3rem'
})
return
}
_this.InvoiceInfo.UserID = Fetch('ID')
this.$vux.confirm.show({
theme: 'ios',
content: `<span style="font-size:20px">确认发票信息信息无误，并创建？</span>`,
confirmText:"确认",
cancelText:"取消",
async onConfirm(){
try {
await Api('CreateInvoiceInfo',_this.InvoiceInfo)
_this.$vux.toast.show({
text: '创建成功',
type: 'text',
width:'3rem'
})
_this.$router.go(-1)
}catch(err) {
_this.$vux.toast.show({
text: '添加发票信息失败',
type: 'cancel',
width:'3rem'
})
}
}
})
}
},
}
